
import { Model } from '@vuex-orm/core';

export default class EventCategory extends Model {
    static entity = 'events-category';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            color: this.attr(''),
            events_count: this.attr(null)
        };
    }

    static apiConfig = {
        actions: {
            fetchCategories() {
                const params = new URLSearchParams();

                return new Promise((resolve, reject) => {
                    this.get('/api/v3/event-categories', {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },
        }
    }
}

window.EventCategory = EventCategory;
